import { render, staticRenderFns } from "./ArmsRegArchiveReturnInfo.vue?vue&type=template&id=775087c3&scoped=true&"
import script from "./ArmsRegArchiveReturnInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveReturnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775087c3",
  null
  
)

export default component.exports